import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { JourCours, Student } from '@app/models/pointage-enseignant';
import { SharedModule } from '@app/modules/shared.module';
import { EnseignantService } from '@app/services/enseignant.service';

export interface EnseignantCoursDetailData {
  jourCours: JourCours;
  idEnseignant: number;
}

@Component({
  selector: 'app-enseignant-cours-detail',
  templateUrl: './enseignant-cours-detail.component.html',
  styleUrls: ['./enseignant-cours-detail.component.scss'],
  imports: [SharedModule]
})
export class EnseignantCoursDetailComponent implements OnInit {

  jourCours: JourCours;
  studentsList: Student[] = [];
  loading = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: EnseignantCoursDetailData,
    private enseignantService: EnseignantService,
  ) {
    this.jourCours = data.jourCours;
  }

  ngOnInit(): void {
    this.enseignantService.getListStudents(this.jourCours.idCours, this.jourCours.idJourCours, this.data.idEnseignant)
      .subscribe({
        next: (students: Student[]) => {
          this.studentsList = (students ?? []).sort((a, b) =>
            a.nomReferent.toLowerCase().localeCompare(b.nomReferent.toLowerCase()));
          this.loading = false;
        },
        error: () => this.loading = false,
      });
  }
}
